import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deletePatientsList } from "../../../redux/patients/action";
import FilledButton from "../../FilledButton";
import { useForm } from "react-hook-form";

const DeletePatientPop = ({ modalVal, handleOpenModal }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const { handleSubmit } = useForm({ mode: "all" });
    const deletePatientListHandler = () => {
        let payload = {
            id: modalVal.id
        }
        setLoading(true)
        dispatch(deletePatientsList(payload)).then(res => {
            if (res.status === 201) {
                setLoading(false)
                handleOpenModal('CommonPop', { header: "Success", body: res.data.message, auth: true })
            }
            else {
                setLoading(false)
                handleOpenModal('CommonPop', { header: "Error", body: res.data.message, auth: true })
            }
        }).catch(e => {
            setLoading(false)
            handleOpenModal('CommonPop', { header: "Error", body: e.message, auth: true })
        })
    }
    return (
        <div className='main_delete_modal'>
            <h4>Delete a Patient?</h4>
            <div className='delete_content'>
                <p>You are about to delete a patient. This will
                    remove all the profile and scheduling information </p>
            </div>
            <span className='reversed'>This action can’t be reversed!</span>
            <span className='proceed'>Do you want to proceed?</span>

            <form onSubmit={handleSubmit(deletePatientListHandler)} className="form_group d_flex justify_content_center form_action delete_modal_btn">
                {/*<button className="btn btn_default" onClick={() => deletePatientListHandler()}>Yes</button>*/}
                <FilledButton type="submit" loading={loading} value={'Yes'} className="btn btn_default" loader_class={'btn_loader_red'} />
                <button className="btn btn_primary" type={'reset'} onClick={() => handleOpenModal()}>No</button>
            </form>
        </div>
    )
}

export default DeletePatientPop